import type { ShareGrid } from './types';
import { dayNumber } from './game';

const EMOJI: Record<string, string> = { correct: '🟩', partial: '🟨', wrong: '🟥' };

// Wordle-style spoiler-free result grid (best-practice §7.3). max null = ∞.
export function shareText(mode: string, grid: ShareGrid, won: boolean, streak: number, attempts: number, max: number | null): string {
  const cap = max ?? '∞';
  const n = won ? `${attempts}/${cap}` : `X/${cap}`;
  const body =
    grid.type === 'grid'
      ? grid.rows.map((row) => row.map((s) => EMOJI[s]).join('')).join('\n')
      : grid.squares.map((b) => (b ? '🟩' : '🟥')).join('');
  const name = mode.charAt(0).toUpperCase() + mode.slice(1);
  return `Animedle ${name} #${dayNumber()} ${n}\n${body}\nStreak ${streak} · animedle.today`;
}

export interface Social {
  key: string;
  label: string;
  color: string;
  href: string;
}

// Social platforms (best-practice §7.3). text already ends with the link.
export function socialLinks(text: string, url: string): Social[] {
  const t = encodeURIComponent(text);
  const u = encodeURIComponent(url);
  return [
    { key: 'x', label: 'X', color: '#000000', href: `https://twitter.com/intent/tweet?text=${t}` },
    { key: 'whatsapp', label: 'WhatsApp', color: '#25D366', href: `https://wa.me/?text=${t}` },
    { key: 'reddit', label: 'Reddit', color: '#FF4500', href: `https://www.reddit.com/submit?url=${u}&title=${encodeURIComponent('Animedle')}` },
    { key: 'telegram', label: 'Telegram', color: '#26A5E4', href: `https://t.me/share/url?url=${u}&text=${t}` },
    { key: 'facebook', label: 'Facebook', color: '#1877F2', href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
  ];
}

export async function copyText(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}

export async function shareOrCopy(text: string): Promise<'shared' | 'copied'> {
  if (navigator.share) {
    try {
      await navigator.share({ text });
      return 'shared';
    } catch {
      /* fall through to copy */
    }
  }
  await navigator.clipboard.writeText(text);
  return 'copied';
}
